import { useState } from 'react';
import { MONTHS_SHORT, toDate } from '../../utils/dates';

const MonthYearSelect = ({ viewDate, minDate, maxDate, onSelect }) => {
    const [year, setYear] = useState(viewDate.getFullYear());

    const min = toDate(minDate);
    const max = toDate(maxDate);

    const isMonthDisabled = (month) => {
        if (min && (year < min.getFullYear() || (year === min.getFullYear() && month < min.getMonth()))) return true;
        if (max && (year > max.getFullYear() || (year === max.getFullYear() && month > max.getMonth()))) return true;
        return false;
    };

    const canStepYear = (delta) => {
        const next = year + delta;
        if (min && next < min.getFullYear()) return false;
        if (max && next > max.getFullYear()) return false;
        return true;
    };

    return (
        <div className="dt-period">
            <div className="dt-period__years">
                <button
                    type="button"
                    className="dt-cal__nav"
                    aria-label="Previous year"
                    disabled={!canStepYear(-1)}
                    onClick={() => setYear(current => current - 1)}
                >
                    <span className="fas fa-chevron-left" aria-hidden="true" />
                </button>
                <span className="dt-period__year">{year}</span>
                <button
                    type="button"
                    className="dt-cal__nav"
                    aria-label="Next year"
                    disabled={!canStepYear(1)}
                    onClick={() => setYear(current => current + 1)}
                >
                    <span className="fas fa-chevron-right" aria-hidden="true" />
                </button>
            </div>

            <div className="dt-period__months">
                {MONTHS_SHORT.map((label, month) => (
                    <button
                        key={label}
                        type="button"
                        disabled={isMonthDisabled(month)}
                        aria-current={year === viewDate.getFullYear() && month === viewDate.getMonth() ? 'true' : undefined}
                        className={[
                            'dt-period__month',
                            year === viewDate.getFullYear() && month === viewDate.getMonth() ? 'is-selected' : '',
                        ].filter(Boolean).join(' ')}
                        onClick={() => onSelect(new Date(year, month, 1))}
                    >
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default MonthYearSelect;
